import VerifiedIcon from '@mui/icons-material/Verified';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const verifiedTagStyle = {
  box: { display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center' },
  icon: { height: '20px', width: '20px' },
};

const ListingCardVerifiedTag = () => {
  return (
    <Box sx={verifiedTagStyle.box}>
      <VerifiedIcon sx={verifiedTagStyle.icon} />
      <Typography color="#fff" lineHeight={1} margin={0} variant="small">
        <FormattedMessage id="ListingCard.verified" />
      </Typography>
    </Box>
  );
};

export default ListingCardVerifiedTag;
